export const getFileUploadApiHeader = () => {
	return {
		headers: {
			'Content-Type': 'multipart/form-data',
			Authorization: localStorage.getItem('accessToken'),
		},
	};
};

export const allowedExtensions = [
	// Drawings
	".dwg", ".dxf", ".svg", ".ai", ".psd", ".skp", ".cdr", ".vsdx", ".dwf",
	// Images
	".jpg", ".jpeg", ".png", ".gif", ".bmp", ".tiff", ".tif", ".webp", ".heic", ".raw", ".ico",
	// PDF
	".pdf",
	// Excel
	".xls", ".xlsx", ".xlsm", ".csv", ".xlt", ".xltx",
	// Word
	".doc", ".docx", ".dot", ".dotx", ".rtf", ".txt",
	// PowerPoint
	".ppt", ".pptx", ".pps", ".ppsx", ".pot", ".potx"
  ];